export default __webpack_public_path__ + "static/media/cusd-celo-logo.ae13a3e8.png";